import Chart from "chart.js/auto";

export default function createChartComponent(chartId, chartType) {
  return {
    props: {
      chartData: {
        type: Object,
        required: true,
      },
      options: {
        type: Object,
        default: () => ({}),
      },
      chartId: {
        type: String,
        default: chartId,
      },
      width: {
        type: Number,
        default: 400,
      },
      height: {
        type: Number,
        default: 400,
      },
      cssClasses: {
        type: String,
        default: "",
      },
      styles: {
        type: Object,
        default: () => ({}),
      },
      plugins: {
        type: Array,
        default: () => [],
      },
    },

    data() {
      return {
        chartInstance: null,
      };
    },

    watch: {
      chartData() {
        this.renderChart();
      },
    },

    mounted() {
      this.renderChart();
    },

    beforeDestroy() {
      this.destroyChart();
    },

    methods: {
      destroyChart() {
        if (!this.chartInstance) return;

        this.chartInstance.destroy();
        this.chartInstance = null;
        this.$emit("chart:destroy");
      },

      renderChart(data = this.chartData, options = this.options) {
        if (!this.$refs.canvas) return;

        this.destroyChart();
        this.chartInstance = new Chart(this.$refs.canvas.getContext("2d"), {
          type: chartType,
          data,
          options,
          plugins: this.plugins,
        });
        this.$emit("chart:render");
      },
    },

    render(createElement) {
      return createElement(
        "div",
        {
          class: this.cssClasses,
          style: this.styles,
        },
        [
          createElement("canvas", {
            ref: "canvas",
            attrs: {
              id: this.chartId,
              width: this.width,
              height: this.height,
            },
          }),
        ]
      );
    },
  };
}
